"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.BlockButtonParams = exports.BlockButtonTopEditor = exports.BlockButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _react2 = require("@chakra-ui/react");

var _immer = _interopRequireDefault(require("immer"));

var _io = require("react-icons/io5");

var _recoil = require("recoil");

var _RecoilStates = require("../../contexts/RecoilStates");

var _ColorPalette = require("../ColorPalette");

var _ParamsPadding = require("../ParamsPadding");

var __jsx = _react["default"].createElement;

/**
 * @param {{
 * block: BlockButton,
 * }} param0
 * @returns
 */
var BlockButton = function BlockButton(_ref) {
  var _block$content$intl$l, _block$content$intl$l2, _block$content$intl$d;

  var block = _ref.block;
  var document = (0, _recoil.useRecoilValue)(_RecoilStates.DocumentState);
  var language = (0, _recoil.useRecoilValue)(_RecoilStates.LanguageState);
  var text = (_block$content$intl$l = (_block$content$intl$l2 = block.content.intl[language.key]) == null ? void 0 : _block$content$intl$l2.text) != null ? _block$content$intl$l : (_block$content$intl$d = block.content.intl[document.language]) == null ? void 0 : _block$content$intl$d.text;
  return __jsx(_react2.Button, {
    width: "100%",
    height: "auto",
    pointerEvents: "none",
    paddingTop: "".concat(block.content.paddingTop, "px"),
    paddingRight: "".concat(block.content.paddingRight, "px"),
    paddingBottom: "".concat(block.content.paddingBottom, "px"),
    paddingLeft: "".concat(block.content.paddingLeft, "px"),
    backgroundColor: block.content.backgroundColor,
    _hover: {
      backgroundColor: block.content.backgroundColor
    },
    borderRadius: "".concat(block.content.borderRadius, "px"),
    borderWidth: "".concat(block.content.borderWidth, "px"),
    borderColor: block.content.borderColor,
    color: block.content.color
  }, text);
};

exports.BlockButton = BlockButton;

/**
 * @param {{
 * block: BlockButton,
 * onUpdate: (block: Block) => {}
 * }} param0
 * @returns
 */
var BlockButtonTopEditor = function BlockButtonTopEditor(_ref2) {
  var _block$content$intl$l3, _block$content$intl$l4, _block$content$intl$d2, _block$content$intl$l5, _block$content$intl$l6, _block$content$intl$d3, _block$content$intl$l7, _block$content$intl$l8;

  var block = _ref2.block,
      onUpdate = _ref2.onUpdate;
  var document = (0, _recoil.useRecoilValue)(_RecoilStates.DocumentState);
  var language = (0, _recoil.useRecoilValue)(_RecoilStates.LanguageState);
  var text = (_block$content$intl$l3 = (_block$content$intl$l4 = block.content.intl[language.key]) == null ? void 0 : _block$content$intl$l4.text) != null ? _block$content$intl$l3 : (_block$content$intl$d2 = block.content.intl[document.language]) == null ? void 0 : _block$content$intl$d2.text;
  var url = (_block$content$intl$l5 = (_block$content$intl$l6 = block.content.intl[language.key]) == null ? void 0 : _block$content$intl$l6.url) != null ? _block$content$intl$l5 : (_block$content$intl$d3 = block.content.intl[document.language]) == null ? void 0 : _block$content$intl$d3.url;

  var updateContentProps = function updateContentProps(changes) {
    var _block = (0, _immer["default"])(block, function (draft) {
      Object.keys(changes).forEach(function (key) {
        draft.content[key] = changes[key];
      });
    });

    onUpdate(_block);
  };

  var onInputTextChange = function onInputTextChange(event) {
    var _block = (0, _immer["default"])(block, function (draft) {
      if (!draft.content.intl[language.key]) {
        draft.content.intl[language.key] = {
          url: null,
          text: ""
        };
      }

      draft.content.intl[language.key].text = event.target.value;
    });

    onUpdate(_block);
  };

  var onInputUrlChange = function onInputUrlChange(event) {
    var _block = (0, _immer["default"])(block, function (draft) {
      if (!draft.content.intl[language.key]) {
        draft.content.intl[language.key] = {
          url: "",
          text: null
        };
      }

      draft.content.intl[language.key].url = event.target.value;
    });

    onUpdate(_block);
  };

  return __jsx(_react["default"].Fragment, null, __jsx(_react2.Stack, null, __jsx(_react2.Box, null, __jsx(_react2.Input, {
    value: text,
    onChange: onInputTextChange,
    placeholder: "Text"
  }), __jsx(_react2.Collapse, {
    "in": !((_block$content$intl$l7 = block.content.intl[language.key]) != null && _block$content$intl$l7.text)
  }, __jsx(_react2.Flex, {
    ml: "4",
    alignItems: "center",
    color: "gray.400"
  }, __jsx(_react2.Icon, {
    as: _io.IoChevronForwardOutline
  }), __jsx(_react2.Text, null, "Valeur par d\xE9faut utilis\xE9e")))), __jsx(_react2.Box, null, __jsx(_react2.Input, {
    value: url,
    onChange: onInputUrlChange,
    placeholder: "https://..."
  }), __jsx(_react2.Collapse, {
    "in": !((_block$content$intl$l8 = block.content.intl[language.key]) != null && _block$content$intl$l8.url)
  }, __jsx(_react2.Flex, {
    ml: "4",
    alignItems: "center",
    color: "gray.400"
  }, __jsx(_react2.Icon, {
    as: _io.IoChevronForwardOutline
  }), __jsx(_react2.Text, null, "Valeur par d\xE9faut utilis\xE9e")))), __jsx(_react2.Box, null, __jsx(_react2.FormControl, {
    display: "flex",
    alignItems: "center"
  }, __jsx(_react2.FormLabel, {
    flexGrow: 1,
    fontWeight: "normal",
    mb: "0",
    ml: "4",
    htmlFor: "switch-autoplay"
  }, "Ouvrir dans un nouvel onglet"), __jsx(_react2.Switch, {
    id: "switch-autoplay",
    isChecked: block.content.openInNewTab,
    onChange: function onChange(event) {
      return updateContentProps({
        openInNewTab: event.target.checked
      });
    }
  })))));
};

exports.BlockButtonTopEditor = BlockButtonTopEditor;

/**
 * @param {{
 * block: BlockButton,
 * onUpdate: (block: Block) => {}
 * }} param0
 * @returns
 */
var BlockButtonParams = function BlockButtonParams(_ref3) {
  var block = _ref3.block,
      onUpdate = _ref3.onUpdate;

  var updateContentProps = function updateContentProps(changes) {
    var _block = (0, _immer["default"])(block, function (draft) {
      Object.keys(changes).forEach(function (key) {
        draft.content[key] = changes[key];
      });
    });

    onUpdate(_block);
  };

  return __jsx(_react["default"].Fragment, null, __jsx(_react2.AccordionItem, null, __jsx(_react2.AccordionButton, null, __jsx(_react2.Box, {
    flex: "1",
    textAlign: "left",
    fontWeight: "medium"
  }, "Marges int\xE9rieures - Bouton"), __jsx(_react2.AccordionIcon, null)), __jsx(_react2.AccordionPanel, {
    pb: 4
  }, __jsx(_ParamsPadding.ParamsPadding, {
    paddingTop: block.content.paddingTop,
    paddingBottom: block.content.paddingBottom,
    paddingLeft: block.content.paddingLeft,
    paddingRight: block.content.paddingRight,
    onUpdate: updateContentProps
  }))), __jsx(_react2.AccordionItem, null, __jsx(_react2.AccordionButton, null, __jsx(_react2.Box, {
    flex: "1",
    textAlign: "left",
    fontWeight: "medium"
  }, "Arri\xE8re-plan - Bouton"), __jsx(_react2.AccordionIcon, null)), __jsx(_react2.AccordionPanel, {
    pb: 4
  }, __jsx(_react2.Stack, {
    my: "2"
  }, __jsx(_react2.InputGroup, null, __jsx(_react2.InputLeftElement, null, __jsx(_react2.Box, {
    width: "20px",
    height: "20px",
    backgroundColor: block.content.backgroundColor,
    transition: "background-color .25s ease"
  })), __jsx(_react2.Input, {
    onChange: function onChange(event) {
      return updateContentProps({
        backgroundColor: event.target.value
      });
    },
    value: block.content.backgroundColor,
    placeholder: "#000000"
  })), __jsx(_ColorPalette.ColorPalette, {
    currentColor: block.content.backgroundColor,
    onChange: function onChange(value) {
      return updateContentProps({
        backgroundColor: value
      });
    }
  })))), __jsx(_react2.AccordionItem, null, __jsx(_react2.AccordionButton, null, __jsx(_react2.Box, {
    flex: "1",
    textAlign: "left",
    fontWeight: "medium"
  }, "Texte - Bouton"), __jsx(_react2.AccordionIcon, null)), __jsx(_react2.AccordionPanel, {
    pb: 4
  }, __jsx(_react2.Stack, {
    my: "2"
  }, __jsx(_react2.InputGroup, null, __jsx(_react2.InputLeftElement, null, __jsx(_react2.Box, {
    width: "20px",
    height: "20px",
    backgroundColor: block.content.color,
    transition: "background-color .25s ease"
  })), __jsx(_react2.Input, {
    onChange: function onChange(event) {
      return updateContentProps({
        color: event.target.value
      });
    },
    value: block.content.color,
    placeholder: "#000000"
  })), __jsx(_ColorPalette.ColorPalette, {
    currentColor: block.content.color,
    onChange: function onChange(value) {
      return updateContentProps({
        color: value
      });
    }
  })))), __jsx(_react2.AccordionItem, null, __jsx(_react2.AccordionButton, null, __jsx(_react2.Box, {
    flex: "1",
    textAlign: "left",
    fontWeight: "medium"
  }, "Bordures - Bouton"), __jsx(_react2.AccordionIcon, null)), __jsx(_react2.AccordionPanel, {
    pb: 4
  }, __jsx(_react2.Stack, {
    direction: "row",
    justifyContent: "space-between"
  }, __jsx(_react2.FormControl, {
    mb: "4",
    width: "45%"
  }, __jsx(_react2.FormLabel, {
    fontWeight: "normal",
    mb: "4"
  }, "Rayon"), __jsx(_react2.NumberInput, {
    onChange: function onChange(valueStr, value) {
      return updateContentProps({
        borderRadius: value
      });
    },
    defaultValue: block.content.borderRadius,
    min: 0,
    max: 100
  }, __jsx(_react2.NumberInputField, null), __jsx(_react2.NumberInputStepper, null, __jsx(_react2.NumberIncrementStepper, null), __jsx(_react2.NumberDecrementStepper, null)))), __jsx(_react2.FormControl, {
    mb: "4",
    width: "45%"
  }, __jsx(_react2.FormLabel, {
    fontWeight: "normal",
    mb: "4"
  }, "\xC9paisseur"), __jsx(_react2.NumberInput, {
    onChange: function onChange(valueStr, value) {
      return updateContentProps({
        borderWidth: value
      });
    },
    defaultValue: block.content.borderWidth,
    min: 0,
    max: 10
  }, __jsx(_react2.NumberInputField, null), __jsx(_react2.NumberInputStepper, null, __jsx(_react2.NumberIncrementStepper, null), __jsx(_react2.NumberDecrementStepper, null))))), __jsx(_react2.Collapse, {
    "in": block.content.borderWidth > 0
  }, __jsx(_react2.Stack, {
    direction: "column"
  }, __jsx(_react2.InputGroup, null, __jsx(_react2.InputLeftElement, null, __jsx(_react2.Box, {
    width: "20px",
    height: "20px",
    backgroundColor: block.content.borderColor,
    transition: "background-color .25s ease"
  })), __jsx(_react2.Input, {
    onChange: function onChange(event) {
      return updateContentProps({
        borderColor: event.target.value
      });
    },
    value: block.content.borderColor,
    placeholder: "#000000"
  })), __jsx(_ColorPalette.ColorPalette, {
    currentColor: block.content.borderColor,
    onChange: function onChange(value) {
      return updateContentProps({
        borderColor: value
      });
    }
  }))))));
};

exports.BlockButtonParams = BlockButtonParams;